import React from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../components/common/Logo";
import Icon from "../components/common/Icon";
import Avatar from "../components/common/Avatar";
import ASSETS from "../data/assets";
import { useAuth } from "../context/AuthContext";

const API_ROOT = (
  process.env.REACT_APP_API_URL ||
  "http://localhost:5000/api"
).replace("/api", "");

const LandingPage = () => {
  const navigate = useNavigate();

  const { user, loading } = useAuth();

  // ✅ Admin Login Check
  const isAdmin =
    localStorage.getItem("isAdminLogin") === "true";

  // ✅ Avatar
  const avatarSrc = user?.avatar
    ? user.avatar.startsWith("/uploads")
      ? `${API_ROOT}${user.avatar}`
      : user.avatar
    : "https://ui-avatars.com/api/?name=Admin+User&background=1F3A60&color=fff";

  return (
    <div
      className="min-h-screen relative overflow-hidden"
      style={{
        backgroundImage: `url(${ASSETS.heroBg})`,
        backgroundSize: "cover",
        backgroundPosition: "bottom",
      }}
    >
      {/* Doves */}
      <img
        src={ASSETS.doves}
        alt=""
        className="absolute left-4 sm:left-[76px] top-[76px] w-[180px] sm:w-[220px] md:w-[340px] lg:w-[444px] pointer-events-none select-none hidden sm:block"
      />

      {/* Header */}
      <header className="relative z-10 flex items-center justify-between px-4 sm:px-6 md:px-10 py-4 sm:py-5">
        <div className="hidden sm:block w-[120px] md:w-[200px]" />

        <Logo size={110} />

        <div className="flex items-center gap-2 sm:gap-3 justify-end px-2 sm:px-5">
          {!loading && (user || isAdmin) ? (
            <>
              <Avatar
                src={avatarSrc}
                alt={user?.name || "Admin User"}
                size={36}
                className="border-2 border-white/50"
              />

              <div className="hidden sm:block">
                <p className="text-white text-[13px] sm:text-[14px] font-semibold">
                  {isAdmin
                    ? "Admin User"
                    : user?.name}
                </p>

                <p className="text-white/60 text-[11px] sm:text-[12px] capitalize">
                  {isAdmin
                    ? "Admin"
                    : `${user?.role} Member`}
                </p>
              </div>
            </>
          ) : (
            <>
              <div className="w-[36px] h-[36px] sm:w-[42px] sm:h-[42px] rounded-full bg-[#B3B3B3]/50 flex items-center justify-center">
                <Icon
                  name="profile"
                  size={18}
                  className="text-[#474747]"
                />
              </div>

              <div className="hidden sm:block">
                <p className="text-white text-[19px] font-semibold">
                  Account
                </p>

                <p className="text-[#FFFFFF] text-[16px]">
                  Hello, Login
                </p>
              </div>
            </>
          )}
        </div>
      </header>

      {/* Hero */}
      <div
        className="relative z-10 flex flex-col items-center justify-center text-center px-4 sm:px-8"
        style={{
          minHeight: "calc(100vh - 140px)",
        }}
      >
        <h1
          className="text-white mb-3 sm:mb-4"
          style={{
            fontFamily:
              '"Praise", Georgia, serif',
            fontWeight: 400,
            fontSize:
              "clamp(40px, 8vw, 120px)",
            lineHeight: "1.1",
            textShadow:
              "0 3px 30px rgba(0,0,0,0.3)",
            maxWidth: 1200,
          }}
        >
          A Digital Temple for Faith &amp;
          Community
        </h1>

        <p className="text-white font-bold text-[12px] sm:text-[14px] md:text-[18px] tracking-[2px] uppercase mb-2 font-body">
          WHERE FAITH CONNECTS.
        </p>

        <p className="text-white/80 text-[14px] sm:text-[16px] md:text-[18px] mb-6 sm:mb-8 font-body">
          A calm space to grow, reflect, and
          build meaningful relationships.
        </p>

        {/* Buttons */}
        {!loading && (user || isAdmin) ? (
          <button
            onClick={() =>
              navigate(
                isAdmin
                  ? "/admin/dashboard"
                  : "/community"
              )
            }
            className="px-8 sm:px-12 py-3 sm:py-3.5 bg-[#E8C547] text-[#1A1A1A] rounded-lg font-bold text-[14px] sm:text-[16px] shadow-lg hover:brightness-110 transition-all font-body"
          >
            {isAdmin
              ? "Go to Admin Dashboard →"
              : "Continue to Platform →"}
          </button>
        ) : (
          <div className="flex gap-3 sm:gap-4">
            <button
              onClick={() =>
                navigate("/signup")
              }
              className="px-6 sm:px-10 py-2.5 sm:py-3 bg-[#E8C547] text-[#1A1A1A] rounded-lg text-[16px] sm:text-[18px] shadow-lg hover:brightness-110 transition-all font-body"
            >
              Join
            </button>

            <button
              onClick={() =>
                navigate("/login")
              }
              className="px-6 sm:px-10 py-2.5 sm:py-3 bg-[#E8C547] text-[#1A1A1A] rounded-lg text-[16px] sm:text-[18px] shadow-lg hover:brightness-110 transition-all font-body"
            >
              Login
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default LandingPage;